import _objectWithoutProperties from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { Field } from 'redux-form'; // import { Field } from 'react-final-form';

import { getCustomStyles, mapValidation } from '@defi/core-utils';
import { withStyles } from '@material-ui/core/styles';
import InputMasked from './InputMasked';
var styles = {
  truncate: {
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  hide: {
    display: 'none'
  },
  default: {
    height: 'auto',
    width: '100%',
    '& input': {
      // padding: '3px',
      // color: '#000',
      // fontSize: '14px',
      // height: 14
      backgroundColor: "transparent !important"
    },
    '& textarea': {
      padding: '3px',
      color: '#000',
      fontSize: 12,
      margin: '0 0 -7px 0',
      paddingTop: 1
    },
    '& p': {
      color: 'red',
      margin: '2px 0'
    }
  },
  edit: {
    '& input, & textarea': {// borderBottom: '2px solid #ccc',
      // backgroundColor: '#fff',
      //  marginTop: '4px'
    }
  },
  disabled: {
    '& textarea': {
      padding: '3px 4px 4px 4px'
    }
  },
  error: {
    '& input': {
      border: '1px solid red',
      marginTop: 5
    }
  },
  floatingText: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '12px',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: 1
  }
};

var TextInput =
/*#__PURE__*/
function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TextInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.reachedMax = _this.props.children.get('Value').length === _this.props.children.getIn(['DataElement', 'FieldLength']);

    _this.handleOnKeyUp = function (e) {
      if (e.target.value.length === _this.props.fieldLength) {
        if (e.key !== 'Tab') {
          if (_this.reachedMax) {
            _this.props.toggleSnackbar(true, 'You have reached the maximum length of this input field', 'red');
          } else {
            _this.reachedMax = true;
          }
        }
      } else {
        _this.reachedMax = false;
      }
    };

    _this.renderTextField = function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          custom = _objectWithoutProperties(_ref, ["input", "label", "meta"]);

      return React.createElement(InputMasked, Object.assign({
        id: String(_this.props.children.get('ElementId')),
        maxLength: _this.props.children.getIn(['DataElement', 'FieldLength']),
        mask: _this.props.mask,
        disabled: false,
        multiline: _this.props.children.get('IsExpandable'),
        className: "".concat(_this.getClasses(), " ").concat(touched && error ? _this.props.classes.errorText : '', " ").concat(_this.props.disabled ? _this.props.classes.hide : '') // floatingLabelText={this.props.name}
        ,
        name: _this.props.name,
        helperText: touched && error
      }, input, custom));
    };

    return _this;
  }

  _createClass(TextInput, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.handleChangeRequirement(this.props.children.get('Value'));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.editStatus && this.props.validation.length > 0) {
        if (!this.props.open) {
          this.props.toggleSection(true);
        }
      }
    }
  }, {
    key: "getClasses",
    value: function getClasses() {
      var _this$props = this.props,
          classes = _this$props.classes,
          editStatus = _this$props.editStatus;
      var statusClass = editStatus ? classes.edit : classes.disabled;
      return "".concat(classes.default, " ").concat(statusClass);
    }
  }, {
    key: "handleChangeRequirement",
    value: function handleChangeRequirement(value) {
      this.props.changeRequirement(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // const customStyles = getCustomStyles(this.props.format);
      var _this$props2 = this.props,
          children = _this$props2.children,
          classes = _this$props2.classes,
          name = _this$props2.name,
          context = _this$props2.context,
          fieldName = _this$props2.fieldName;
      return React.createElement(React.Fragment, null, React.createElement("span", {
        title: name,
        className: classes.floatingText
      }, name), React.createElement(Field, {
        context: context,
        id: String(children.get('ElementId')),
        name: fieldName,
        component: this.renderTextField,
        onKeyUp: this.handleOnKeydUp,
        validate: this.props.valiation,
        onBlur: function onBlur(e) {
          return _this2.handleChangeRequirement(e.target.value);
        }
      }));
    }
  }]);

  return TextInput;
}(Component);

export default withStyles(styles)(TextInput);